import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPreferences, savePreferences } from '../APIServices/PreferencesService';
import { activateLoading, deactivateLoading } from './GlobalSlice';
export interface IpreferencesState {
  preferencesData: any;
}

const initialState: IpreferencesState = {
  preferencesData: null,
};

export const preferences = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    resetPreferencesData: (state, action) => {
      state.preferencesData = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPreferences.fulfilled, (state, action) => {
      if (action?.payload) {
        state.preferencesData = action?.payload?.preferences;
      }
    });
    builder.addCase(updatePreferences.fulfilled, (state, action) => {
      if (action?.payload?.preferences) {
        state.preferencesData = action?.payload?.preferences;
      }
    });
  },
});

export const { resetPreferencesData } = preferences.actions;
export default preferences.reducer;

export const getPreferences = createAsyncThunk(
  'preferences/getPreferences',
  async (showLoader: boolean = true, { dispatch }) => {
    showLoader && dispatch(activateLoading());
    const response: any = await fetchPreferences();
    showLoader && dispatch(deactivateLoading());
    return response;
  },
);
export const updatePreferences = createAsyncThunk(
  'preferences/updatePreferences',
  async (queryPayload: any, { dispatch }) => {
    dispatch(activateLoading());
    const response: any = await savePreferences(queryPayload);
    dispatch(deactivateLoading());
    return response;
  },
);
